import styled from "styled-components";

export const Container = styled.div`
  background-color: #d7f0db;
  display: flex;
  align-items: center;
  height: 80px;
  justify-content: space-between;
  padding: 0 40px;
  width: 100%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

  .left-content {
    display: flex;
    align-items: center;
    gap: 40px;
  }

  .logo {
    display: flex;
    align-items: center;
    img {
      height: 60px;
      width: auto;
    }
  }

  .nav-links {
    display: flex;
    gap: 20px;
    @media (max-width: 850px) {
      display: none;
    }

    a {
      text-decoration: none;
      color: #585858;
      font-weight: 500;
      font-size: 16px;
      transition: color 0.2s;

      &:hover,
      &.active {
        color: #008037;
      }
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 15px;

    p {
      margin: 0;
      color: #585858;
      font-weight: 500;
      @media (max-width: 600px) {
        display: none;
      }
    }

    .profile-button {
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
      display: flex;
      align-items: center;

      img {
        width: 45px;
        height: 45px;
        border-radius: 50%;
        object-fit: cover;
      }
    }

    .logout-button {
      background: #f44336;
      color: white;
      border: none;
      padding: 6px 15px;
      border-radius: 50px;
      cursor: pointer;
      font-weight: bold;
      font-size: 12px;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.8;
      }
    }
  }
`;
